import React, { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X, ArrowRight } from "lucide-react";
import Logo from "./Logo";

const nav = [
  { to: "/", label: "Home" },
  { to: "/about-us", label: "About" },
  { to: "/#solutions", label: "Solutions" },
  { to: "/#why-us", label: "Why Us" },
  { to: "/#blog", label: "Blog" },
];

export default function Header() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setOpen(false);
  }, [pathname]);

  return (
    <header
      className={`sticky top-0 z-50 w-full transition-all ${
        scrolled
          ? "border-b border-ink-900/5 bg-white/90 backdrop-blur-md"
          : "bg-transparent"
      }`}
    >
      <div className="container-page flex h-20 items-center justify-between">
        <Link to="/" className="flex items-center" aria-label="SnapPay home">
          <Logo className="h-9" />
        </Link>

        <nav className="hidden items-center gap-8 md:flex">
          {nav.map((item) => (
            <NavItem key={item.to} item={item} />
          ))}
        </nav>

        <div className="hidden items-center gap-3 md:flex">
          <Link to="/contact-us" className="btn-primary">
            Get Started
            <ArrowRight className="h-4 w-4" />
          </Link>
        </div>

        <button
          type="button"
          className="inline-flex h-10 w-10 items-center justify-center rounded-full border border-ink-900/10 bg-white text-ink-900 md:hidden"
          onClick={() => setOpen((v) => !v)}
          aria-label="Toggle menu"
        >
          {open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
        </button>
      </div>

      {open && (
        <div className="md:hidden">
          <div className="container-page pb-6">
            <div className="flex flex-col gap-1 rounded-2xl border border-ink-900/5 bg-white p-4 shadow-card">
              {nav.map((item) => (
                <NavItem key={item.to} item={item} mobile />
              ))}
              <Link to="/contact-us" className="btn-primary mt-2 w-full">
                Get Started
                <ArrowRight className="h-4 w-4" />
              </Link>
            </div>
          </div>
        </div>
      )}
    </header>
  );
}

function NavItem({ item, mobile }) {
  const isHash = item.to.includes("#");
  const base = mobile
    ? "px-4 py-3 rounded-xl text-sm font-medium text-ink-700 hover:bg-brand-50 hover:text-brand-700"
    : "text-sm font-medium text-ink-700 transition hover:text-brand-600";
  if (isHash) {
    return (
      <Link to={item.to} className={base}>
        {item.label}
      </Link>
    );
  }
  return (
    <NavLink
      to={item.to}
      end
      className={({ isActive }) =>
        `${base} ${isActive ? (mobile ? "bg-brand-50 text-brand-700" : "text-brand-600") : ""}`
      }
    >
      {item.label}
    </NavLink>
  );
}
